export enum VariantType {
  COLOUR = 'colour',
  DIMENSIONS = 'dimensions'
}
